import { NavLink } from "react-router";
import homePic from "../misc-photos/home-pic.png";
import { onNavigate } from "../utilities/Utilities";

const Home = () => {
    return (
        <div className="home-container">
            <div>
                <h1 className={'home-title title-font'}>Welcome to <br /> the artroom!</h1>
                <img className={'home-image'} src={homePic} alt="home" style={{ maxWidth: '100vw', objectFit: 'contain' }} />
            </div>
            <div className="a align-self-center">
                <div className="d-flex flex-column home-button-container">
                    <NavLink onClick={onNavigate} className="home-button text-color home-button-text" to="/studentwork"><i className="fa-solid fa-palette"></i> Student Work</NavLink>
                    <NavLink onClick={onNavigate} className="home-button text-color home-button-text" to="/lessons"><i className="fa-solid fa-person-chalkboard"></i> Lessons</NavLink>
                    <NavLink onClick={onNavigate} className="home-button text-color home-button-text" to="/about"><i className="fa-solid fa-paintbrush"></i> About the Teacher</NavLink>
                </div>
            </div>
        </div>
    );
}

export default Home;